import { uniq } from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import ToastrAction from 'toastr/actions/ToastrAction'
import Checkbox from '../../../../components/forms/Checkbox'
import Input from '../../../../components/forms/Input'
import RadioButtons from '../../../../components/forms/RadioButtons'
import Select from '../../../../components/forms/Select'
import NetworkAction from '../../../../referencial/components/network/actions/NetworkAction'
import NetworkDto from '../../../../referencial/components/network/dto/NetworkDto'
import AppStore from '../../../../store/AppStore'
import Job from '../../../dto/DtoJob'
import SuperMultiAutocomplete from '../../../../components/forms/SuperMultiAutocomplete'
import SupportDto from '../../../../referencial/components/support/dto/SupportDto'
import Supportaction from '../../../../referencial/components/support/actions/SupportAction'
import CampaignAction from '../../../../campaign/actions/CampaignAction'
import CampaignDto from '../../../../campaign/dto/CampaignDto'
import { getIntegrationModes } from '../../../../utils/JobUtils'
import { exportFile } from '../../../../utils/ExportDataUtil'
import { nbPerPageLabelMedium } from '../../../../referencial/constants/ReferencialConstants'
import { CardTable } from '../../../../components/datatable/NewTable'
import { Grid2 } from '@mui/material'
import ImportQualityDefaultValue from '../ImportQualityDefaultValue'
import { readImportCsvStationsCodes } from '../../utils/ImportUtils'
import SimpleDatePicker from 'components/forms/SimpleDatePicker'
import { getDate, getTimestamp } from 'utils/DateUtil'
import IntegrationModeDialog from '../IntegrationModeDialog'

class HubeauHydrobiopanel extends Component {
    componentDidMount() {
        const filters = this.getFilters()
        this.onChangeFilters({
            selectStationsMode: filters.selectStationsMode
                || 'codesMode', stationCodes: filters.stationCodes
                    || (this.props.job.parameters.supports && this.props.job.parameters.supports.length ? this.props.job.supports.parameters : []),
        })
        this.props.fetchNetworks()
        this.props.fetchSupports()
        this.props.fetchQualityCampaigns()
    }

    onDeleteBssCode = ({ bsscode }) => {
        if (this.props.isEditMode) {
            const filters = this.getFilters()
            this.onChangeFilters({ stationCodes: filters.stationCodes.filter(p => p !== bsscode) })
        }
    }
    onDeleteCode = (s) => {
        if (this.props.isEditMode) {
            const filters = this.getFilters()
            this.onChangeFilters({ stationCodes: filters.stationCodes.filter(p => p !== s.credentials) })
        }
    }

    addBssCode = () => {
        if (this.props.isEditMode) {
            const filters = this.getFilters()
            const code = this.refs.txtAddBssCode.value
            const exist = filters.stationCodes.find(p => p.toLowerCase() == code.toLowerCase())
            if (!code) {
                AppStore.dispatch(ToastrAction.error(i18n.youMustEnterAtLeastOneBssCode))
            } else if (exist) {
                AppStore.dispatch(ToastrAction.error(i18n.youHaveAlreadyEnteredThisBssCode))
            } else {
                this.onChangeFilters({ stationCodes: [code, ...filters.stationCodes] })
                this.refs.txtAddBssCode.value = ''
            }
        }
    }

    onChangeBssFile = e => {
        if (this.props.isEditMode) {
            readImportCsvStationsCodes(e, this.refs, (codes) => {
                const filters = this.getFilters()
                this.onChangeFilters({ stationCodes: uniq([...filters.stationCodes, ...codes]) })
            })
        }
    }

    getStations = () => {
        return this.getFilters().stationCodes.map((v) => ({ credentials: v }))
    }

    handleChangeDataIntegration = integration => {
        const { parameters } = this.props.job
        const dataTypes = parameters.dataTypes.filter(d => !d.includes('DATA'))
        if (integration) {
            dataTypes.push(integration)
        }
        this.props.onChangeDataTypes(dataTypes)
    }

    handleChangeStationIntegration = integration => {
        const { parameters } = this.props.job
        const dataTypes = parameters.dataTypes.filter(d => !d.includes('station'))
        if (integration) {
            dataTypes.push('stationIntegration')
        }
        this.props.onChangeDataTypes(dataTypes)
    }

    onChangeFilters = (changes) => {
        const parameters = {
            ...this.props.job.parameters,
            filters: [JSON.stringify({
                ...this.getFilters(),
                ...changes,
            })],
        }
        this.props.onChangeJob({ parameters })
    }

    getFilters = () => {
        const newFilters = this.props.job.parameters.filters.length ? JSON.parse(this.props.job.parameters.filters[0]) : {}
        return { descriptionImportMode: 'all', addCodesToADESNetwork: true, ...newFilters }
    }

    getStationsPanel = () => {
        const disabled = { disabled: !this.props.isEditMode }
        const myData = this.getStations()
        return (
            <>
                <Grid2 size={3}>
                    <label>{i18n.importFile}</label>
                </Grid2>
                <Grid2 size={2}>
                    <div className='file-field no-padding btn' style={{ width: '100%', marginTop: 0 }}>
                        <span>{i18n.importLabel}</span>
                        <input
                            type='file'
                            ref='importFile'
                            accept='.csv'
                            onChange={this.onChangeBssFile}
                            {...disabled}
                        />
                    </div>
                </Grid2>
                <Grid2 size={7}>
                    <div className='file-path-wrapper'>
                        <input
                            className='file-path'
                            ref='fileInput'
                            type='text'
                            placeholder={i18n.selectedFile}
                            style={{ marginBottom: 0 }}
                            {...disabled}
                        />
                    </div>
                </Grid2>
                <Grid2 size={3}>
                    <label>{i18n.addCredential}</label>
                </Grid2>
                <Grid2 size={6}>
                    <div style={{ position: 'relative' }}>
                        <label className='tinyLabel' style={{ position: 'absolute' }}>
                            {i18n.theCodeMustBePresentInTheRepositoryAndDefinedByTheCode}
                        </label>
                        <input id='txtAddBssCode' type='text' placeholder={i18n.BSSExample} ref='txtAddBssCode' {...disabled} style={{ marginTop: '16px', marginBottom: 0 }} />
                    </div>
                </Grid2>
                <Grid2 size={2} offset={1}>
                    <a
                        className='waves-effect waves-light btn'
                        onClick={this.addBssCode}
                        style={{ width: '100%' }}
                        {...disabled}
                    >
                        {i18n.add}
                    </a>
                </Grid2>
                <Grid2 size={12}>
                    <CardTable
                        rows={myData}
                        headers={['credentials']}
                        title={i18n.credentials}
                        lineActions={[{
                            icon: 'delete',
                            onClick: (s) => this.onDeleteCode(s),
                            displayed: this.props.isEditMode,
                        }]}
                        rowsPerPageOptions={nbPerPageLabelMedium}
                        data-cy='Synop_table_body'
                        actions={[{
                            icon: 'download',
                            onClick: () => exportFile({
                                data: [{ ...(myData[0]), headers: ['credentials'] }, ...(myData.slice(1, myData.length))],
                                titleFile: i18n.credentials,
                            }),
                            tooltip: i18n.download,
                        }]}
                        displayHeaders={false}
                    />
                </Grid2>
            </>
        )
    }

    getFiltersPanel = (filters) => {
        const disabled = { disabled: !this.props.isEditMode }
        return (
            <>
                <Grid2 size={5}>
                    <Select
                        options={this.props.networks}
                        keyLabel='mnemonic'
                        label={i18n.network}
                        nullLabel='&nbsp;'
                        onChange={value => this.onChangeFilters({ network: value })}
                        value={filters.network}
                        {...disabled}
                        keyValue='id'
                    />
                </Grid2>
                <Grid2 size={4}>
                    <Input
                        title={i18n.departmentNumber}
                        onChange={v => this.onChangeFilters({ departmentCodes: v })}
                        value={filters.departmentCodes}
                        placeholder='Ex: 44,85,49'
                        {...disabled}
                    />
                </Grid2>
            </>
        )
    }

    handleChangeDataIntegration = integration => {
        const { parameters } = this.props.job
        const newDataTypes = (() => {
            const data = parameters.dataTypes.filter(d => !d.includes('DATA'))
            if (integration) {
                return [...data, integration]
            }
            return data
        })().filter(s => !s.includes('data'))
        this.props.onChangeDataTypes(newDataTypes)
    }


    getDataTypes = type => {
        const { parameters } = this.props.job
        if (parameters.dataTypes && parameters.dataTypes.length) {
            return parameters.dataTypes.find(d => d.includes(type)) || ''
        }
        return ''
    }


    render() {
        const disabled = { disabled: !this.props.isEditMode }
        const selectModes = [
            { code: 'codesMode', name: i18n.stations },
            { code: 'filtersMode', name: i18n.filters },
        ]
        const filters = this.getFilters()

        const startDate = getTimestamp(filters.date_first, 'YYYY-MM-DD')
        const endDate = getTimestamp(filters.date_end, 'YYYY-MM-DD')

        return (
            <Grid2 container spacing={1} alignItems='center'>
                <Grid2 size={4}>
                    <Select
                        value={this.getDataTypes('DATA')}
                        options={getIntegrationModes()}
                        label={i18n.dataIntegration}
                        labelSpan={<IntegrationModeDialog />}
                        obligatory
                        onChange={this.handleChangeDataIntegration}
                        {...disabled}
                    />
                </Grid2>
                <Grid2 size={4}>
                    <SuperMultiAutocomplete
                        label={i18n.support}
                        options={this.props.supports}
                        keyLabel='labelWithCode'
                        onChange={values => this.onChangeFilters({ supports: values })}
                        values={filters.supports}
                        multiple
                        {...disabled}
                    />
                </Grid2>
                <Grid2 size={4}>
                    <Select
                        value={filters.campaignId}
                        options={this.props.qualityCampaigns.filter(cs => cs.campaignType === 2)}
                        label={i18n.campaign}
                        onChange={v => this.onChangeFilters({ campaignId: v })}
                        {...disabled}
                    />
                </Grid2>
                <Grid2 size={12}>
                    <fieldset>
                        <Grid2 container spacing={1}>
                            <Grid2 size={3}>
                                <Checkbox
                                    checked={filters.addIndice}
                                    label={i18n.indices}
                                    onChange={v => this.onChangeFilters({ addIndice: v })}
                                    {...disabled}
                                />
                            </Grid2>
                            <Grid2 size={3}>
                                <Checkbox
                                    checked={filters.addTaxon}
                                    label={i18n.taxons}
                                    onChange={v => this.onChangeFilters({ addTaxon: v })}
                                    {...disabled}
                                />
                            </Grid2>
                            <Grid2 size={3}>
                                <Checkbox
                                    checked={filters.addFish}
                                    label={i18n.fish}
                                    onChange={v => this.onChangeFilters({ addFish: v })}
                                    {...disabled}
                                />
                            </Grid2>
                        </Grid2>
                    </fieldset>
                </Grid2>
                <Grid2 size={3}>
                    <RadioButtons
                        title={i18n.selectionMode}
                        elements={selectModes}
                        onChange={v => this.onChangeFilters({ selectStationsMode: v })}
                        selected={filters.selectStationsMode}
                        {...disabled}
                    />
                </Grid2>
                <Grid2 size={3}>
                    <Checkbox
                        checked={filters.addCodesToADESNetwork}
                        label={i18n.addCodesToADESNetwork}
                        onChange={v => this.onChangeFilters({ addCodesToADESNetwork: v })}
                        {...disabled}
                    />
                </Grid2>
                <Grid2 size={3}>
                    <Checkbox
                        checked={filters.stationUpdate}
                        label={i18n.integrateStationInfo}
                        onChange={v => this.onChangeFilters({ stationUpdate: v })}
                        {...disabled}
                    />
                </Grid2>
                <Grid2 size={3}>
                    <Select
                        options={this.props.networks}
                        keyLabel='mnemonic'
                        label={i18n.synchNetwork}
                        nullLabel='&nbsp;'
                        onChange={value => this.onChangeFilters({ selectedNetwork: value })}
                        value={filters.selectedNetwork}
                        disabled={disabled.disabled || !filters.addCodesToADESNetwork}
                        keyValue='id'
                    />
                </Grid2>
                <Grid2 size={3}>
                    <SimpleDatePicker
                        id='startDate'
                        label={i18n.startDate}
                        value={startDate}
                        onChange={value => this.onChangeFilters({ date_first: getDate(value, 'YYYY-MM-DD') })}
                        max={endDate}
                        {...disabled}
                    />
                </Grid2>
                <Grid2 size={3}>
                    <SimpleDatePicker
                        id='endDate'
                        label={i18n.endDate}
                        value={endDate}
                        onChange={value => this.onChangeFilters({ date_end: getDate(value, 'YYYY-MM-DD') })}
                        min={startDate}
                        {...disabled}
                    />
                </Grid2>
                <Grid2 size={12}>
                    <ImportQualityDefaultValue
                        defaultValue={filters.qualityDefaultValue}
                        onChange={obj => {
                            this.onChangeFilters({ qualityDefaultValue: { ...filters.qualityDefaultValue, ...obj } })
                        }}
                        isEditMode={this.props.isEditMode}
                        hydrobio
                    />
                </Grid2>
                {filters.selectStationsMode === 'codesMode' ? this.getStationsPanel() : this.getFiltersPanel(filters)}
            </Grid2>
        )
    }
}

HubeauHydrobiopanel.propTypes = {
    job: PropTypes.instanceOf(Job).isRequired,
    addBssCode: PropTypes.func.isRequired,
    isEditMode: PropTypes.bool,
    onChangeDataTypes: PropTypes.func.isRequired,
    onChangeFilters: PropTypes.func,
    onChangeJob: PropTypes.func,
    supports: PropTypes.arrayOf(PropTypes.instanceOf(SupportDto)),
    networks: PropTypes.arrayOf(PropTypes.instanceOf(NetworkDto)),
    fetchSupports: PropTypes.func,
    fetchNetworks: PropTypes.func,
    fetchQualityCampaigns: PropTypes.func,
    qualityCampaigns: PropTypes.arrayOf(PropTypes.instanceOf(CampaignDto)),
}

const mapStateToProps = store => ({
    networks: store.NetworkReducer.networks,
    supports: store.SupportReducer.supports,
    qualityCampaigns: store.QualityReducer.qualityCampaigns,
})

const mapDispatchToProps = {
    fetchNetworks: NetworkAction.fetchNetworks,
    fetchSupports: Supportaction.fetchSupports,
    toastrError: ToastrAction.error,
    fetchQualityCampaigns: CampaignAction.fetchQualityCampaigns,
}

export default connect(mapStateToProps, mapDispatchToProps)(HubeauHydrobiopanel)
